import produce from 'immer';

const INITIAL_STATE = {
  seal: {},
  history: [],
  status: '',
  errorSeal: false,
};

const seal = (state = INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@seal/FETCH_SEAL':
        draft.seal = action.payload;
        draft.errorSeal = action.false;
        break;
      case '@seal/FETCH_HISTORY':
        draft.history = action.payload;
        break;
      case '@seal/FETCH_DATA':
        draft.status = 'fetching';
        break;
      case '@seal/FETCH_DATA_FINALLY':
        draft.status = '';
        break;
      case '@seal/ERROR_SEAL':
        draft.errorSeal = true;
        break;
      default:
        return state;
    }
  });
};

export default seal;
